import { Grid, Typography } from '@material-ui/core'

export const darkGrey = '#575757'

export const startStateNameToRequiredAction = {
  "Acceptez-vous l'intervention?": "Accepter l'intervention",
  "L'intervention est-elle terminée?": "Marquer l'intervention comme terminée",
  'Merci de déposer votre devis': 'resources.invoice.send_quote',
  "Acceptez-vous l'intervention réalisée?": "Évaluer l'intervention",
}
export const defaultActionDescription = 'Valider cette étape'
export const requiredActionDescription = (
  is_presta,
  state_transition_description
) => {
  if (!is_presta) return defaultActionDescription

  return (
    startStateNameToRequiredAction[state_transition_description] ||
    defaultActionDescription
  )
}
export const isActionRequired = (state_transition) => {
  if (
    state_transition != null &&
    (state_transition.input_columns.length > 0 || state_transition.can_forward)
  ) {
    return true
  }
  return false
}
export const requiredAction = (state_transition) => {
  if (isActionRequired(state_transition))
    return 'Nous attendons une action de votre part :'

  return 'Aucune action nécessaire de votre part !'
}
export const isLastStep = (record) => {
  if (record === undefined) return false
  return (
    record.step_rank !== undefined &&
    parseInt(record.step_rank) === parseInt(record.max_rank)
  )
}
export const filterGardien = (str) => {
  if (str === null) {
    return null
  }
  return ' - ' + str
}
export const DisplayGardien = (props) => {
  const { nom, email, tel } = props
  if (nom === null) {
    return null
  }
  return (
    <div>
      Gardien(ne): {nom} {filterGardien(email)} {filterGardien(tel)}
      <br />
    </div>
  )
}

export const canShowInvoiceWrapper = (record) => {
  if (
    (record.state_transition &&
      [
        //  Petit interventions
        12, // Intervention acceptée
        13, // Intervention terminée
        14, // Intervention évaluée
        47, // Devis uploadé
        // Interventions urgentes
        19, // Intervention acceptée
        20, // Intervention terminée
        21, // Intervention évaluée,
      ].indexOf(record.state_transition?.start_state_id) === -1) ||
    !record.is_presta
  ) {
    return false
  } else true
}

export const OverParagraph = () => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={11} md={11}>
        <div>
          <Typography style={{ color: '#575757' }}>
            Merci ! Ce dossier est désormais clôturé. Vous pouvez contacter
            l'équipe Support en cas de besoin.
          </Typography>
        </div>
      </Grid>
    </Grid>
  )
}
